import {useQuery} from '@tanstack/react-query';
import {apiClient} from '../../../../lib/api-client';
import {EstimatedProduct} from "../types/EstimatedProduct";
import {ProductQty} from "../types/ProductQty";
import {ProductQtyId} from "../types/ProductQtyId";

export const useEstimateProducts = (dealerId: number, products: ProductQtyId[], optionalProducts: ProductQtyId[], zipCode: string, retailPriceBucketId: number | undefined, disabled: boolean) => {
    const {data, isLoading, refetch} = useQuery({
        queryKey: ['ee-tool-estimate-products', dealerId, zipCode, retailPriceBucketId, JSON.stringify(products), JSON.stringify(optionalProducts)],
        queryFn: async () => {
            if (products.length === 0) {
                return [] as EstimatedProduct[];
            }
            let total = products.reduce((acc, item) => acc + item.Quantity, 0);
            if (total === 0) {
                return [] as EstimatedProduct[];
            }

            return await apiClient.post('ee-tool/estimate-products', {
                dealerID: dealerId,
                products: products.concat(optionalProducts),
                zipCode: zipCode,
                retailPriceBucketId: retailPriceBucketId
            }) as EstimatedProduct[]
        },
        enabled: !disabled && !!products,
        staleTime: 5 * 60 * 1000
    });

    return {
        data: data || [] as EstimatedProduct[],
        isLoading: isLoading,
        refetch: refetch
    };
};
